export default {
  home: {
    sections: {
      trendingToday: "Tendances du jour",
      offers: "Offres",
      partners: "Partenaires",
      cheatsheets: "Aide-mémoire",
      predictionMarkets: "Marchés de prédiction",
      advancedTools: "Outils avancés",
      parlays: "Paris combinés",
      upcomingGames: "Matchs à venir",
    },
    offers: {
      types: {
        FANTASY_FREE_PICK: "Choix du jour",
        BOOST: "Boosts",
        SPORTSBOOK_SIGNUP: "Sportsbook",
        FANTASY_SIGNUP: "Fantasy",
        PREDICTION_SIGNUP: "Prédiction",
        SWEEPSTAKES_SIGNUP: "Sweepstakes",
        CASINO_SIGNUP: "Casino",
        PARTNER: "Partenaires",
      },
    },
    offseason: {
      eyebrow: "Hors saison",
      body: "À bientôt pour la nouvelle saison!",
    },
    seasonChampion: {
      description: "{{team}} sont les {{championship}}.",
      descriptionWithArticle: "Les {{team}} sont les {{championship}}.",
      descriptions: {
        default: "Champions {{league}}",
        superbowl: "Champions du Super Bowl",
        stanleyCup: "Champions de la Coupe Stanley",
        premierLeague: "Champions de Premier League",
        worldSeries: "Champions de la Série mondiale",
        european: "Champions d'Europe",
        europaLeague: "Champions de la Ligue Europa",
        ncaaBasketball: "Champions NCAA de basketball",
        ncaaFootball: "Champions NCAA de football",
      },
    },
    noGamesToday: "Il n'y a aucun match aujourd'hui en {{league}}.",
    currentlyInOffseason: "Actuellement hors saison.",
    featured: {
      gameOfDay: "Match du jour",
      gameOfWeek: "Match de la semaine",
      parlayTrends: "Tendances de combinés",
      cheatsheets: "Aide-mémoire",
      unlockRewardTitle: "Débloquez votre récompense",
      unlockRewardSubtitle: "Réclamez l'accès premium pour en voir plus.",
      unlockRewardBody: "Accédez à plus de tendances, d'outils et d'analyses.",
    },
    cards: {
      placeItOn: "Pariez sur",
      advancedToolsCta: "Rejoindre Linemate+",
      premiumBlurb: "Débloquez l'expérience complète. Analysez chaque tendance plus en profondeur.",
    },
    empty: {
      trend: "Aucune tendance disponible. Veuillez revenir plus tard.",
      cheatsheet: "Aucun aide-mémoire disponible. Veuillez revenir plus tard.",
      offer: "Aucune offre disponible. Veuillez revenir plus tard.",
    },
    cheatsheets: {
      recentForm: "Forme récente",
      versusOpponent: "Contre l'adversaire",
      alternateLines: "Lignes alternatives",
      firstQuarter: "1er quart",
      firstHalf: "1re demie",
      homeAwayGames: "Matchs domicile/extérieur",
      teamForm: "Forme de l'équipe",
      undersOnly: "Moins seulement",
    },
    tools: {
      props: "Props",
      markets: "Marchés",
      cheatsheets: "Aide-mémoire",
      generateParlay: "Créateur de combinés",
      lineups: "Alignements",
      injuries: "Blessures",
      rank: "Classement",
      weather: "Météo",
      pitchers: "Lanceurs",
      stats: "Stats",
      standings: "Classements",
    },
    generateParlay: {
      parlayType: {
        subtitle: "Utilisez la forme récente, les confrontations ou les performances à domicile et à l'extérieur.",
        recentFormDescription: "Performances sur les 20 derniers matchs",
        versusOpponentDescription: "20 derniers matchs contre cet adversaire",
        homeAwaySplitsDescription: "20 derniers matchs à domicile ou à l'extérieur",
      },
      legs: {
        title: "Combien de sélections souhaitez-vous ?",
        subtitle: "Choisissez la taille du combiné que vous souhaitez générer",
        label: "{{count}} sélections",
      },
      participants: {
        title: "Qui souhaitez-vous inclure ?",
        subtitle: "Choisissez les équipes ou les joueurs que vous souhaitez inclure dans votre combiné",
        searchPlayer: "Rechercher un joueur",
        searchTeam: "Rechercher une équipe",
        allPlayers: "Tous les joueurs",
        allTeams: "Toutes les équipes",
      },
      result: {name: "Combiné", title: "Votre combiné"},
      empty: {
        title: "Aucun combiné trouvé",
        subtitle: "Modifiez vos sélections pour générer un combiné.",
      },
      actions: {goHome: "Retour à l'accueil", share: "Partager le combiné"},
      loader: {
        ready: "Combiné prêt",
        accessibilityLabel: "Génération de votre combiné",
        values: {
          legs: "{{count}} sélections...",
          allGames: "Tous les matchs...",
          selectedGames: "{{count}} matchs...",
          allPlayers: "Tous les joueurs...",
          allTeams: "Toutes les équipes...",
          selectedParticipants: "{{count}} participants...",
          selectedBetTypes: "{{count}} types de paris...",
          selectedSportsbooks: "{{count}} sportsbooks...",
          building: "Création de votre combiné...",
        },
      },
    },
    predictionMarkets: {
      hubTitle: "Centre des marchés de prédiction",
      values: {
        points: "{{count}} pts",
        trades: "{{count}} transactions",
      },
      analysis: {
        title: "Analyse du marché",
        allExchanges: "Toutes les plateformes",
        perExchange: "Par plateforme",
        chips: {
          all: "Tout",
          oneDay: "1 jour",
          oneWeek: "1 semaine",
        },
        rows: {
          volume: "Volume",
          movement: "Variation",
          marketSplit: "Écart du marché",
          largestTrade: "Plus grosse transaction",
          activity: "Activité",
        },
      },
      cards: {
        mostVolume: {
          title: "Plus gros volume",
          description: "Marchés avec le plus d'argent échangé",
        },
        largestTrades: {
          title: "Plus grosses transactions",
          description: "Marchés avec les plus grosses transactions individuelles",
        },
        biggestMovers: {
          title: "Plus fortes variations",
          description: "Marchés avec les plus grands changements de probabilité",
        },
        marketsSplit: {
          title: "Écart des marchés",
          description: "Marchés avec les plus grands écarts entre plateformes",
        },
        mostActivity: {
          title: "Plus d'activité",
          description: "Marchés avec le plus grand nombre de transactions",
        },
      },
      previews: {
        superBowlWinner: "Vainqueur du Super Bowl",
        nbaChampions: "Champions NBA",
        worldSeriesWinner: "Vainqueur de la Série mondiale",
        easternConference: "Conférence Est",
        westernConference: "Conférence Ouest",
        nfcWinner: "Vainqueur NFC",
        afcChampions: "Champions AFC",
        alPennant: "Fanion AL",
        stanleyCup: "Coupe Stanley",
        afcEast: "AFC Est",
        afcNorth: "AFC Nord",
        nfcNorth: "NFC Nord",
        nfcWest: "NFC Ouest",
        nlCentral: "NL Centrale",
        nlWest: "NL Ouest",
        premierLeague: "Premier League",
        divisionWinner: "Vainqueur de division",
      },
    },
    advancedTools: {
      marketAgainst: "{{market}} contre",
      vsOpponent: "c. {{opponent}}",
    },
    sponsoredBy: "Commandité par {{operator}}",
  },
};
